// eslint-disable-next-line import/no-unresolved
import auth from '@/middleware/auth'

const formTable = [
  // CREATIONS
  {
    path: '/finanzas/list',
    name: 'finanzas-list',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/administration/finanzas/Finanzas.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'finanzas',
    },
  },
  {
    path: '/finanzas/payment',
    name: 'finanzas-payment',
    // eslint-disable-next-line import/no-unresolved
    component: () => import('@/views/administration/finanzas/utils/BalanceUpdate.vue'),
    meta: {
      layout: 'content',
      middleware: auth,
      pertenece: 'finanzas',
    },
  },
]

export default formTable
